export default "__VITE_ASSET__9b9b05f2__"